import axios from 'axios';
import { API_BASE_URL } from '../../../constants';
import { useEffect, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { getCloudImageUrl } from 'utils';

export function useFetchSearchBannerData() {
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    setIsFetching(true);
    axios
      .get(`${API_BASE_URL}/promos?category=all_category`)
      .then((res) => {
        const newValue = res.data.data.map((banner) => {
          if (banner.images.length === 0) {
            return {
              name: banner.name,
              image: '',
              redirectUrl: banner.redirect_url,
            };
          }
          return {
            name: banner.name,
            image: banner.img_url,
            redirectUrl: banner.redirect_url,
          };
        });

        setData(newValue.slice(0, 2));
        setIsFetching(false);
      })
      .catch((err) => {
        console.error('failed to fetch', err);
        setIsFetching(false);
      });
  }, []);

  return {
    isFetching,
    data,
  };
}
